// Module
var code = "<maintenance-reports selected-business=\"$parent.$ctrl.selectedBusiness\"></maintenance-reports> ";
// Exports
export default code;